import React from "react";
import styled from "styled-components";

const Button = styled.button`
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 50px;
    padding: 0 24px;

    background: transparent;
    border: 0;
    color: #f5c18d;

    font-family: "Courier New", monospace;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 1.5px;
    cursor: pointer;
    isolation: isolate;

    transition: filter 0.15s ease;

    &:hover {
        filter: brightness(1.2);
    }

    &:active {
        filter: brightness(0.9);
    }

    &:focus-visible {
        outline: 2px solid #ffb46b;
        outline-offset: 3px;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;

const Frame = styled.svg`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: visible;
    pointer-events: none;
`;

const Content = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  z-index: 1;
`;

export const DataPadButton = ({
								  children, icon, variant = "primary", onClick, disabled, ...props
                              }
							  : {
	children: React.ReactNode, icon: React.ReactNode, variant?: "primary" | "secondary",
	onClick?: () => void,
	disabled?: boolean, props?: any
}) => {
	const primary = variant === "primary";

	const border = primary ? "#F1A052" : "#A3693E";
	const innerBorder = primary ? "#D57A2B" : "#85502D";
	const background = primary ? "#55270F" : "#32190D";

	return (
		<Button type="button" {...props} onClick={onClick} disabled={disabled}>
			<Frame
				viewBox="0 0 340 56"
				preserveAspectRatio="none"
				aria-hidden="true"
			>
				<defs>
					<linearGradient
						id={`frame-fill-${variant}`}
						x1="0"
						y1="0"
						x2="1"
						y2="1"
					>
						<stop offset="0%" stopColor={background}/>
						<stop offset="100%" stopColor="#241107"/>
					</linearGradient>
				</defs>

				{/* Äußerer technischer Rahmen */}
				<path
					d="
            M 8 1
            H 331
            L 339 9
            V 47
            L 331 55
            H 8
            L 1 48
            V 9
            Z
          "
					fill={border}
					stroke={border}
					strokeWidth="1"
				/>

				{/* Innerer Rahmen mit 3px Abstand */}
				<path
					d="
            M 11 4
            H 329
            L 336 11
            V 45
            L 329 52
            H 11
            L 4 45
            V 11
            Z
          "
					fill={`url(#frame-fill-${variant})`}
					stroke={innerBorder}
					strokeWidth="1"
				/>

				{/* Verstärkte linke obere Ecke */}
				<path
					d="M 5 19 V 9 L 12 3 H 37"
					fill="none"
					stroke="#F5A75C"
					strokeWidth="2"
				/>

				{/* Kurze obere Leiterbahn */}
				<path
					d="M 15 8 H 54"
					fill="none"
					stroke="#E68A38"
					strokeWidth="0.8"
					opacity="0.7"
				/>

				{/* Untere rechte Eckverzierung */}
				<path
					d="M 304 53 H 330 L 337 46"
					fill="none"
					stroke="#C77732"
					strokeWidth="1.2"
				/>

				{/* Kleine technische Einkerbung */}
				<path
					d="M 7 42 V 47 L 12 52 H 29"
					fill="none"
					stroke="#B7662B"
					strokeWidth="0.8"
				/>
			</Frame>

			<Content>
				{icon}
				{children}
			</Content>
		</Button>
	);
}